import {
  GET_PRODUCT,
  SHOW_PRODUCT_LOADING,
  PRODUCT_ERROR,
  GET_PRODUCT_DETAILS,
  CREATE_PRODUCT_SUCCESS,
  EDIT_PRODUCT_SUCCESS,
  DELETE_PRODUCT,
  SHOW_EDIT_PRODUCT_LOADING
} from '../actions/types';

/**.
 * maco-magsael-sc-913: Product - Product feature creation
 */

const initialState = {
  productlist: [],
  productID: null,
  productDetails: null,
  productLoading: false,
  editProductLoading: false,
  error: {}
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_PRODUCT_LOADING:
      return {
        ...state,
        productLoading: true
      };
    case SHOW_EDIT_PRODUCT_LOADING:
      return {
        ...state,
        editProductLoading: true
      };
    case GET_PRODUCT:
      return {
        ...state,
        productlist: payload,
        productLoading: false
      };
    case GET_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: payload,
        productLoading: false
      };
    case CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        productlist: [payload, ...state.productlist],
        productLoading: false
      };

    case EDIT_PRODUCT_SUCCESS:
      return {
        ...state,
        productlist: state.productlist.map((product) =>
          product._id === payload._id ? { ...product, ...payload } : product
        ),
        productDetails: {
          ...state.productDetails,
          ...payload
        },
        editProductLoading: false,
        productLoading: false
      };

    case DELETE_PRODUCT:
      return {
        ...state,
        productlist: state.productlist.filter(
          (product) => product._id !== payload
        ),
        productLoading: false
      };
    case PRODUCT_ERROR:
      return {
        ...state,
        error: payload,
        productLoading: false
      };
    default:
      return state;
  }
}
